export default __webpack_public_path__ + "static/media/img-9.9b8c0ad4.png";